// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"094bc33d","383":"4706a7f2","401":"3c6db1dc","409":"4dced85b","426":"274cf9b0","453":"6be1075a","466":"b5583130","508":"0a14eec1","867":"37858733"}[chunkId] + ".chunk.js";
};